module.exports = "<div ng-repeat=\"listing in $ctrl.data | orderBy: 'meta.creationDate':true\">\r\n    <div ng-show=\"$index > 0\" style=\"width:100%; text-align:center\">\r\n        <img src=\"./assets/images/line-divider.png\" />\r\n    </div>\r\n    <bulletin-post data=\"listing\" preview=\"true\" property=\"true\" url=\"$ctrl.url\"></bulletin-post>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./client/components/bulletin/property-list/bulletin-property-list.html
// module id = 114
// module chunks = 0